import { TableHeader, TableHeaderColumn } from '@rio-cloud/rio-uikit/Table';
import classnames from 'classnames';

import styles from './styles/DataTable.module.scss';
import type { TableActionColumnConfig, TableColumn } from './types';

interface DataTableHeaderProps<T extends object> {
    columns: readonly TableColumn<T>[];
    actionColumn?: TableActionColumnConfig<T>;
    className?: string;
    sticky?: boolean;
}

const DataTableHeader = <T extends object>({ columns, actionColumn, className, sticky }: DataTableHeaderProps<T>) => (
    <TableHeader className={classnames(styles.DataTable__headerCell, 'width-100pct', className)} sticky={sticky}>
        {columns.map(column => (
            <TableHeaderColumn
                key={String(column.key)}
                columnKey={String(column.key)}
                label={column.title}
                width={column.width}
                horizontalAlign={column.align}
                className={classnames(
                    'border-bottom-only text-size-14 line-height-14 padding-x-15 text-color-darkest text-medium white-space-normal text-left',
                    column.className
                )}
                sortable={column.sortable}
            />
        ))}
        {actionColumn && (
            <TableHeaderColumn columnKey='actions' width={actionColumn.width ?? 80} horizontalAlign='right' hideLabel />
        )}
    </TableHeader>
);

export default DataTableHeader;
